import { siteInfo } from '@/mocks/buzz';

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden pt-16"
      style={{
        backgroundImage:
          'url("https://readdy.ai/api/search-image?query=Vibrant%20editorial%20flat%20lay%20of%20watermelon%20slices%2C%20colorful%20confetti%20and%20popcorn%20on%20a%20warm%20cream%20paper%20background%2C%20bold%20fun%20magazine%20cover%20composition%2C%20soft%20natural%20light%2C%20cheerful%20and%20fresh%20atmosphere&width=1600&height=820&seq=hero-chigua-2026&orientation=landscape")',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/85 to-paper/20" />
      <div className="relative mx-auto flex w-full max-w-7xl flex-col px-4 pb-12 pt-10 md:px-6 md:pb-20 md:pt-16">
        <div className="inline-flex w-fit items-center gap-2 rounded-full border border-coral-200 bg-white/70 px-3 py-1.5 text-xs font-bold text-coral-600">
          <span className="flex h-2 w-2 items-center justify-center">
            <i className="ri-flashlight-fill" />
          </span>
          今日已更新 6 条速览 · 实时刷新
        </div>

        <h1 className="mt-5 max-w-3xl font-display text-4xl leading-tight md:text-6xl md:leading-tight">
          一分钟瓜快速回顾
          <br />
          <span className="text-coral-500">精简爆料直击重点</span>
        </h1>

        <p className="mt-5 max-w-xl text-base leading-7 text-ink-soft md:text-lg">
          {siteInfo.desc}高效汇总当日要闻，通勤路上轻松补完全部课代表内容，从此追热点不掉队。
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a
            href="#today"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-coral-500 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-coral-600"
          >
            立即开吃今日瓜
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#column"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-ink/15 bg-white/70 px-6 py-3 text-sm font-bold text-ink transition-colors hover:border-ink hover:bg-white"
          >
            看课代表专栏
          </a>
        </div>

        <div className="mt-9 grid max-w-2xl grid-cols-3 gap-3">
          {[
            { icon: 'ri-time-line', t: '每日三档更新' },
            { icon: 'ri-focus-3-line', t: '热度实时排行' },
            { icon: 'ri-scissors-2-line', t: '要点精简提炼' },
          ].map((f) => (
            <div
              key={f.t}
              className="flex flex-col items-center gap-2 rounded-2xl border border-paper bg-white/80 px-3 py-4 text-center"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-coral-50 text-coral-600">
                <i className={`text-lg ${f.icon}`} />
              </span>
              <span className="text-xs font-bold text-ink">{f.t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}